// Moved from `src/hooks/query/useQueryTeamDetails.ts` (now a bare re-export)
// with OT3 slice 2 (ARCFE-955). The toast severed per ARCFE-921: the legacy
// catch toasted only for transport (axios) errors, reading the backend detail.
// The undefined-swallow is frozen.
//
// The reaction moved from a per-caller `onFetchError` option to
// `WorkspaceDataConfig.onTeamDetailsFetchError`. A `queryFn`
// belongs to the QUERY, not to an observer, so an option-borne port fired by
// mount order — see `useQueryTeamDetails.test.tsx`, which pins both the old
// rule and the new one. Config binds it once, so the reaction is now a
// property of the fetch rather than of whoever won the race to start it.
import { useQuery } from '@tanstack/react-query';

import { GET_TEAM_DETAILS } from '../../contracts/keys';
import { getTeamDetails } from '../api/teams';
import { getWorkspaceDataConfig, isTransportError } from '../config';

export { GET_TEAM_DETAILS };

export function useQueryTeamDetails(teamId?: string) {
  return useQuery({
    queryKey: [GET_TEAM_DETAILS, { teamId }],
    enabled: !!teamId,
    // Team details (incl. team_members) change when someone joins/leaves. The
    // global 1h staleTime would stop refetchOnWindowFocus/Mount from ever
    // firing, so the admin's member list goes stale. This query is only mounted
    // while viewing a team, so a short staleTime is cheap. See APP-5390 / APP-5396.
    staleTime: 60 * 1000,
    queryFn: async () => {
      try {
        if (teamId) {
          const { data } = await getTeamDetails(teamId);
          return data;
        }
      } catch (error) {
        if (isTransportError(error)) {
          getWorkspaceDataConfig().onTeamDetailsFetchError?.(error);
        }
      }
    },
  });
}
